import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, CreditCardIcon, DumbbellIcon, FileTextIcon, FlagIcon, LockIcon, ShoppingCartIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroTestimonials, productMockupUrl } from '../data/content';
const badges = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: CalendarDaysIcon,
  label: '8 Semanas'
}, {
  icon: DumbbellIcon,
  label: 'Todos los niveles'
}, {
  icon: FlagIcon,
  label: 'Método argentino'
}];
const stats = [{
  value: '+800',
  label: 'clientes transformados'
}, {
  value: '6',
  label: 'Tomos listos'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}];
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-132" data-mp="3d2l8d8tzsyz4">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-133" data-mp="380w1849w55gb" data-mpi={index} />)}
    </div>;
}
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink" data-id="element-134" data-mp="3o73no75q7m5y">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[520px] w-[900px] -translate-x-1/2 rounded-full bg-electric/10 blur-[140px]" aria-hidden="true" data-id="element-135" data-mp="39autvl4lu10x" />
      <div className="relative mx-auto max-w-6xl px-5 pb-16 pt-6 text-center sm:px-8 sm:pb-24 sm:pt-12" data-id="element-136" data-mp="30iawsp3yo4i7">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-base font-extrabold uppercase tracking-[0.22em] text-gold sm:text-lg" data-id="element-137" data-mp="3599jc6fjlytw">
          🏋️ Núcleo Fit
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.03,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-2 text-sm font-bold uppercase tracking-[0.18em] text-neutral-400 sm:text-base" data-id="element-138" data-mp="2hk86m6zog1it">
          MegaPack Definición Inteligente
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-4 max-w-4xl text-[2rem] font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-139" data-mp="ic873bxiq0w9">
          Todo tu cuerpo definido.
          <span className="mt-1 block text-gold-gradient" data-id="element-140" data-mp="162ccnou9oapw">
            Listo. Desde hoy.
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto -mt-4 max-w-[340px] sm:-mt-2 sm:max-w-xl" data-id="element-141" data-mp="114kkqutmgolp">
          <img src={productMockupUrl} alt="MegaPack Definición Inteligente: caja con los 6 tomos principales y las 5 herramientas bonus" className="mx-auto w-full drop-shadow-[0_30px_60px_rgba(245,197,66,0.18)]" width={1024} height={1024} data-id="element-142" data-mp="3htg8k5ll6fha" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto -mt-12 max-w-3xl text-base font-bold leading-snug text-gold sm:-mt-24" data-id="element-143" data-mp="2b0fwpfpuynbt">
          El sistema N°1 para bajar grasa y construir abdomen definido — sin
          vivir pesando comida ni haciendo mil abdominales.
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-neutral-300 sm:text-base" data-id="element-144" data-mp="2tyino01yuuc9">
          Rutinas cortas + comida simple + reglas sin fricción listos para usar.
          Sin buscar. Sin armar. Sin perder el fin de semana.
        </p>

        <ul className="mx-auto mt-5 flex max-w-3xl flex-wrap items-center justify-center gap-1.5 sm:gap-2.5" data-id="element-145" data-mp="4bdx7gy3ybp5">
          {badges.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-line bg-surface px-2.5 py-1.5 text-[11px] font-bold text-neutral-200 sm:gap-2 sm:px-4 sm:py-2 sm:text-sm" data-id="element-146" data-mp="3vhfcy2t0pth4">
              <Icon className="h-3 w-3 shrink-0 text-gold sm:h-4 sm:w-4" aria-hidden="true" data-id="element-147" data-mp="3hphd6il759xm" />
              {label}
            </li>)}
        </ul>

        <div className="mx-auto mt-6 max-w-md" data-id="element-148" data-mp="3rh58iukvjb4d">
          <CtaButton className="py-4 text-base sm:py-5 sm:text-lg" data-id="element-149" data-mp="3rhwst990tmfc">
            QUIERO MI MEGAPACK AHORA
          </CtaButton>
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-medium text-neutral-500" data-id="element-150" data-mp="2yzj0tqad8uo6">
            <li className="inline-flex items-center gap-1.5" data-id="element-151" data-mp="2tzmw1otugz7k">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-152" data-mp="19ixci09itial" />
              Garantía 7 días
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-153" data-mp="1e9vquuay86b7">
              <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-154" data-mp="1eb6y543lrw72" />
              Pago seguro
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-155" data-mp="14jayholvby0q">
              <ShoppingCartIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-156" data-mp="14ju3k4qf6rxc" />
              Mercado Pago
            </li>
          </ul>
        </div>

        <dl className="mx-auto mt-10 grid max-w-4xl grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-157" data-mp="1x8rnsde6yysq">
          {stats.map(stat => <div key={stat.label} className="rounded-2xl border border-line bg-surface px-4 py-5" data-id="element-158" data-mp="1j7f9s7ild79h">
              <dt className="sr-only" data-id="element-159" data-mp="1nc507guhdtn0">{stat.label}</dt>
              <dd data-id="element-160" data-mp="7s8nqq2y3amx">
                <span className="block text-2xl font-extrabold text-gold sm:text-3xl" data-id="element-161" data-mp="7rqm1dxik47m">
                  {stat.value}
                </span>
                <span className="mt-1 block text-xs font-medium text-neutral-400" data-id="element-162" data-mp="2ehkdp5mxuf9h">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <ul className="mx-auto mt-6 grid max-w-6xl gap-4 text-left lg:grid-cols-3" data-id="element-163" data-mp="24rr4uce6ke8x">
          {heroTestimonials.map(item => <li key={item.initials} className="flex flex-col rounded-2xl border border-line bg-surface p-5" data-id="element-164" data-mp="1ztfsnv0exrnj">
              <div className="flex items-center gap-3" data-id="element-165" data-mp="1vopz4ct88p5s">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold/15 text-sm font-extrabold text-gold" data-id="element-166" data-mp="1qqybhuzm7p7e">
                  {item.initials}
                </span>
                <Stars data-id="element-167" data-mp="1gv3lget2arul" />
              </div>
              <p className="mt-3 text-sm leading-relaxed text-neutral-300" data-id="element-168" data-mp="1gw6ccmqdwuai">
                “{item.quote}”
              </p>
              <p className="mt-auto pt-3 text-xs font-bold text-neutral-500" data-id="element-169" data-mp="3b7baxcmm6giz">
                — {item.name}, {item.location}
              </p>
            </li>)}
        </ul>
      </div>
    </header>;
}